<template>
  <!--BOOST LANDING PAGE: Story CD-18 -->
  <div>
    <div v-if="isLoading" class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1000]">
      <CustomSkeleton />
    </div>
    <iframe
      :src="iframeUrl"
      frameborder="0"
      name="layup-iframe"
      title="layup-iframe"
      class="w-full h-[690px]"
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import CustomSkeleton from '@/components/common/CustomSkeleton.vue';
import { BASE_URL } from '@/config';
import { computed, ref } from 'vue';

interface Props {
  orderId: string;
}

const props = defineProps<Props>();

const isLoading = ref(true);

const iframeUrl = computed(() => {
  return `${BASE_URL}/shopper/payment-plan/${props.orderId}/contribute`;
});

const onIframeLoad = () => {
  isLoading.value = false;
};
</script>
